import { Box, Grow, makeStyles } from "@material-ui/core";
import React from "react";
import { SKILLS } from "./helper";

const Skill = () => {
  const useStyles = makeStyles(() => ({
    box: {
      "@media (min-width: 768px)": {
        padding: "0 80px",
      },
      "@media (max-width: 450px)": {
        padding: "20px 60px",
      },
    },
  }));

  const classes = useStyles();

  const Card = ({ url, width, height }) => {
    return (
      <Box
        // marginRight={5}
        // marginBottom={2}
        width={90}
        height={90}
        borderRadius={12}
        padding={2}
        bgcolor={"white"}
        display="flex"
        alignItems="center"
        justifyContent="center"
        border={"2px solid #cecece"}
        boxShadow={"0 0 20px rgb(157 158 163 / 80%)"}
      >
        <img
          src={url}
          width={width}
          height={height}
          style={{
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
          alt={"Skill"}
        />
      </Box>
    );
  };

  return (
    <Grow in={true} timeout={3000}>
      <Box
        className={classes.box}
        display="flex"
        alignItems="center"
        flexWrap={"wrap"}
        justifyContent="center"
        gridGap={"24px"}
      >
        {SKILLS.map((item) => (
          <Card
            key={item.name}
            url={item.url}
            width={item.width}
            height={item.height}
          />
        ))}
      </Box>
    </Grow>
  );
};

export default Skill;
